import {
  Box,
  Button,
  Checkbox,
  FileInput,
  Group,
  LoadingOverlay,
  Modal,
  Select,
  Text,
  TextInput,
  Textarea,
  rem,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { isNotEmpty, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCheck,
  IconCircleMinus,
  IconCirclePlus,
  IconFileCv,
  IconMinus,
  IconPlus,
  IconRotateClockwise,
} from "@tabler/icons-react";
import moment from "moment";
import { useEffect, useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { isNullOrUndefined } from "../../../_base/extension/StringExtension";
import { formatFormData } from "../../../_base/helper/FunctionHelper";
import Repository from "../../../_base/helper/HttpHelper";
import { getArticleCategory, modifyArticleList } from "../../../api/ApiArticle";
import { uploadFile } from "../../../api/ApiProduct";
import ButtonClose from "../../../common/ButtonClose/ButtonClose";
import QuillEditor from "../../../common/QuillEditor";
import { ArticleList } from "../../../model/Article";
import { MessageResponse } from "../../../model/MessageResponse";
import { convertImageDomain } from "../../../const/converhandle";

interface CategoryList {
  catid: number;
}

interface IsImageChangeType {
  thumnail: boolean;
  imageBackground: boolean;
}

const EditView = ({ onSearch, id }: any) => {
  const entity = {
    type: "",
    title: "",
    videoCode: "",
    externalUrl: "",
    url: "",
    requestPath: "",
    urlHash: "",
    thumnail: "",
    imageBackground: "",
    extend: "",
    summary: "",
    tags: "",
    creationDate: null,
    createdBy: null,
    lastUpdateDate: null,
    lastUpdatedBy: null,
    ordering: null,
    reviewRate: null,
    reviewCount: null,
    status: 2,
    visit: null,
    likeCount: null,
    isFeatured: null,
    approvedStatus: null,
    metaTitle: "",
    metaKeywords: "",
    metaDescription: "",
    commentCount: null,
    commentRate: null,
    postedDate: "",
    isStricking: "",
    content: "",
    imagePath: "",
    imageDetailPath: "",
    articleCategory: ",60,",
    allowSeIndex: "",
    tblArticleImageCommands: [],
    tblArticleCategoryDetModels: [],
    listCategoryId: [],
  };

  const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [valueDescription, setValueDescription] = useState(null);
  const [dataArcticleCategory, setDataArcticleCategory] = useState<any>();
  const [selectedItems, setSelectedItems] = useState<CategoryList[]>([]);
  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set());
  const icon = (
    <IconFileCv style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
  );
  const [title, setTitle] = useState("");
  const [summary, setSummary] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [timeOption, setTimeOption] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [modalImageUrl, setModalImageUrl] = useState<string | null>(null);
  const [modalOpened, setModalOpened] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  // Hàm để đếm số từ
  const countWords = (text: string | null) => {
    if (text === null) {
      return 0; // Trả về 0 nếu text là null
    }

    const words = text.split(/\s+/).filter((word) => word !== "");
    return words.length;
  };

  // Hàm để đếm số kí tự
  const countCharacters = (text: string | null) => {
    if (text === null) {
      return 0; // Trả về 0 nếu text là null
    }

    return text.length;
  };

  const handleChangeDataContent = (content: string | null) => {
    let modifiedString = content?.replace(
      /src="\/media/g,
      'src="https://hanoicomputercdn.com/media'
    );
    return modifiedString ? modifiedString : "";
  };
  console.log("valueDescription", valueDescription);

  const handleCreateArticleList = async (dataSubmit: ArticleList) => {
    open();
    if (timeOption === "now") {
      dataSubmit.postedDate = moment(form.getValues().creationDate).format(
        "YYYY-MM-DDTHH:mm:ss"
      );
    }

    // Loại bỏ thumnail và imageBackground khỏi dataSubmit vì sẽ gửi file thật qua FormData
    const { content, ...restData } = form.getValues();
    // Đảm bảo attribute1 và attribute2 không null khi submit
    if (restData.attribute1 === null || restData.attribute1 === undefined) {
      restData.attribute1 = "1";
    }
    if (restData.attribute2 === null || restData.attribute2 === undefined) {
      restData.attribute2 = "1";
    }

    // Xử lý requestPath và url
    let requestPath = restData.requestPath || "";
    if (requestPath && !requestPath.startsWith("/")) {
      requestPath = "/" + requestPath;
    }
    restData.requestPath = requestPath;

    // Nếu requestPath có dấu / ở đầu thì bỏ đi khi gán vào url
    restData.url = requestPath.startsWith("/")
      ? requestPath.slice(1)
      : requestPath;

    // Tạo FormData để gửi file binary giống EditView của Category
    const formData = new FormData();

    // Xử lý từng field một cách rõ ràng
    Object.keys(restData).forEach((key) => {
      const value = (restData as any)[key];

      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          // Xử lý array - gửi từng phần tử với index
          value.forEach((item, index) => {
            if (item !== null && item !== undefined) {
              formData.append(`${key}[${index}]`, item.toString());
            }
          });
          console.log(`Array ${key}:`, value); // Debug array
        } else if (typeof value === "object" && !(value instanceof File)) {
          // Xử lý object phức tạp
          formatFormData(value, formData, key);
        } else {
          // Xử lý giá trị đơn giản
          formData.append(key, value.toString());
        }
      }
    });

    // Thêm nội dung đã xử lý
    formData.append(
      "content",
      handleChangeDataContent(
        // Tại sao phải check thế này , vì khi thay đổi nội dung sẽ nhận giá trị ở valueDescription còn nếu k thay đổi thì lấy giá trị cũ để đẩy lên
        valueDescription ? valueDescription : form.getValues().content
      )
    );
    console.log(Array.from(formData.entries()));
    await modifyArticleList(formData);
    onSearch();
    close();
    modals.closeAll();
  };

  const handleInputChange = (fieldName: string, value: string) => {
    switch (fieldName) {
      case "metaTitle":
        setMetaTitle(value);
        form.setValues({ metaTitle: value });
        break;
      case "metaKeywords":
        setMetaKeywords(value);
        form.setValues({ metaKeywords: value });
        break;
      case "metaDescription":
        setMetaDescription(value);
        form.setValues({ metaDescription: value });
        break;
      case "title":
        setTitle(value);
        form.setValues({ title: value });
        break;
      case "summary":
        setSummary(value);
        form.setValues({ summary: value });
        break;
      default:
        break;
    }
  };
  const form = useForm<ArticleList>({
    initialValues: {
      ...entity,
    },
    validate: {
      title: (value: string | null) => {
        return !value || /^\s*$/.test(value)
          ? "Chưa nhập loại bài viết"
          : // : /[^\w\sĂăÂâẹếÀàÃãỰựsàáạãảăắằẳẵặâầấẩẫậèéẹẽẻêềếểễệđìíịĩỉòóọõỏôồốổỗộơờớởỡợùúụũủưừứửữựỳýỵỹỷ]/.test(
            //     value
            //   )
            // ? "Tiêu đề không được nhập kí tự đặc biệt"
            undefined;
      },
      // status: isNotEmpty("Chưa chọn trạng thái"),
      summary: isNotEmpty("Chưa nhập bản tóm tắt"),
      // ordering: isNotEmpty("Chưa nhập thứ tự"),
      metaTitle: isNotEmpty("Chưa nhập tiêu đề meta"),
      url: isNotEmpty("Chưa nhập URL"),
      metaKeywords: isNotEmpty("Chưa nhập từ khóa meta"),
      metaDescription: isNotEmpty("Chưa nhập mô tả meta"),
      postedDate: (value) => {
        if (timeOption === "custom" && (!value || /^\s*$/.test(value))) {
          return "Bạn cần chọn thời gian đăng tải";
        }
        return null;
      },
    },
  });
  console.log("form.getValue()", form.getValues());
  // Hàm để toggle expand/collapse danh mục
  const toggleExpanded = (itemId: number) => {
    setExpandedItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(itemId)) {
        newSet.delete(itemId);
      } else {
        newSet.add(itemId);
      }
      return newSet;
    });
  };

  // Hàm đệ quy để render cây danh mục
  const renderCategoryTree = (categories: any[], level: number = 0) => {
    return categories.map((item: any) => {
      const hasChildren =
        item.tblArticleCategoryModels &&
        item.tblArticleCategoryModels.length > 0;
      const isExpanded = expandedItems.has(item.id);

      return (
        <Box key={item.id}>
          {/* Render checkbox cho danh mục hiện tại */}
          <Group
            gap="xs"
            wrap="nowrap"
            style={{ marginLeft: `${level * 20}px` }}
          >
            {/* Icon expand/collapse chỉ hiện khi có danh mục con */}
            {hasChildren ? (
              <Box
                style={{
                  cursor: "pointer",
                  minWidth: "20px",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => toggleExpanded(item.id)}
              >
                {isExpanded ? (
                  <IconCircleMinus size={20} color="#1976d2" />
                ) : (
                  <IconCirclePlus size={20} color="#1976d2" />
                )}
              </Box>
            ) : (
              <Box style={{ minWidth: "20px" }} />
            )}

            {/* Checkbox */}
            <Checkbox
              style={{
                paddingTop: "4px",
                paddingBottom: "4px",
                fontWeight: "normal",
              }}
              label={item.name}
              checked={selectedItems.some(
                (selectedItem) => selectedItem.catid === item.id
              )}
              onChange={() => handleCheckboxChange(item.id)}
            />
          </Group>

          {/* Render danh mục con (đệ quy) - chỉ hiện khi expanded */}
          {hasChildren &&
            isExpanded &&
            renderCategoryTree(item.tblArticleCategoryModels, level + 1)}
        </Box>
      );
    });
  };

  const handleCheckboxChange = (catid: number) => {
    setSelectedItems((prevItems) => {
      const itemIndex = prevItems.findIndex((item) => item.catid === catid);
      if (itemIndex !== -1) {
        const newSelectedItems = [...prevItems];
        newSelectedItems.splice(itemIndex, 1);
        const newArray = newSelectedItems.map((item) => item.catid);
        form.setValues({ listCategoryId: newArray });
        return newSelectedItems;
      } else {
        const newArray = [...prevItems, { catid }];
        form.setValues({ listCategoryId: newArray.map((item) => item.catid) });
        return newArray;
      }
    });
  };

  const handleChangeStatus = (id: string | null) => {
    if (id !== null) {
      form.getInputProps("status").onChange(Number(id));
    } else {
      form.getInputProps("status").onChange(null);
    }
  };
  const fetchDataArticleCategory = async () => {
    try {
      const data = await getArticleCategory("Take=1000");
      if (data?.data) {
        // const modifiedData = data.data.map(
        //   (item: { id: number; name: string; code: string }) => ({
        //     id: item.id,
        //     name: item.name,
        //     code: item.code,
        //   })
        // );
        // setDataArcticleCategory(modifiedData);
        setDataArcticleCategory(data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  console.log("dataArcticleCategory", dataArcticleCategory);

  useEffect(() => {
    const callApiGetData = async () => {
      await fetchDataArticleCategory();
      open();
      const urlDetail = `/TblArticle/details?id=${id}`;
      let callApi = await repository.post<MessageResponse<ArticleList>>(
        urlDetail
      );
      if (!isNullOrUndefined(callApi) && !isNullOrUndefined(callApi?.data)) {
        const dataApi = callApi?.data;
        if (dataApi != null && !isNullOrUndefined(dataApi)) {
          // if (
          //   dataApi.thumnail !== null &&
          //   dataApi.thumnail !== undefined &&
          //   typeof dataApi.thumnail == "string"
          // ) {
          //   dataApi.thumnail = await urlToImageFile(dataApi.thumnail);
          // }
          // if (
          //   dataApi.imageBackground !== null &&
          //   dataApi.imageBackground !== undefined &&
          //   typeof dataApi.imageBackground == "string"
          // ) {
          //   dataApi.imageBackground = await urlToImageFile(
          //     dataApi.imageBackground
          //   );
          // }
          form.setValues(dataApi);
          const catIdObjects = dataApi.tblArticleCategoryDetModels
            .map((item: any) => ({ catid: item.catId } as CategoryList))
            .filter((catIdObj) => catIdObj.catid !== undefined);
          setSelectedItems(catIdObjects);
          form.setValues({
            listCategoryId: catIdObjects.map((item) => item.catid),
          });
          setTitle(dataApi.title);
          setSummary(dataApi.summary);
          setMetaTitle(dataApi.metaTitle);
          setMetaKeywords(dataApi.metaKeywords);
          setMetaDescription(dataApi.metaDescription);
        } else {
          NotificationExtension.Fails("Dữ liệu không tồn tại");
          modals.closeAll();
        }
        close();
      } else {
        NotificationExtension.Fails("Dữ liệu không tồn tại");
        modals.closeAll();
      }
    };

    if (id || id === 0) {
      callApiGetData();
    }
  }, [id]);
  // Hàm helper để format URL ảnh
  const formatImageUrl = (
    imageValue: string | File | null | undefined
  ): string => {
    if (typeof imageValue === "string" && imageValue !== "") {
      // Nếu là string và bắt đầu bằng http hoặc https thì hiển thị luôn
      if (
        imageValue.startsWith("http://") ||
        imageValue.startsWith("https://")
      ) {
        return imageValue;
      }
      // Nếu không thì thêm CDN URL cho bài viết
      return `https://hanoicomputercdn.com/media/Article/${imageValue}`;
    }

    return "#";
  };

  const handleImgUrlChange = async (file: File | null) => {
    if (file) {
      const result = await uploadFile([file], "article");
      if (result && result.success && result.data && result.data[0]?.url) {
        form.setFieldValue("thumnail", result.data[0].url);
      } else {
        NotificationExtension.Fails("Tải ảnh lên thất bại!");
      }
    }
  };

  const handleImgBigChange = async (file: File | null) => {
    if (file) {
      const result = await uploadFile([file], "article");
      if (result && result.success && result.data && result.data[0]?.url) {
        form.setFieldValue("imageBackground", result.data[0].url);
      } else {
        NotificationExtension.Fails("Tải ảnh nền lên thất bại!");
      }
    }
  };

  console.log("form.getValues()", form.getValues());
  console.log("form.Values()", form.values);
  return (
    <>
      <Box
        className="flex-none"
        component="form"
        miw={1300}
        maw={1500}
        mx="auto"
        onSubmit={form.onSubmit((e: ArticleList) => {
          handleCreateArticleList(e);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <>
          <Text size="sm" mt="sm" fw={700}>
            Danh mục (có thể chọn nhiều danh mục)
          </Text>
          <Group grow wrap="wrap" gap={"lg"}>
            <Box style={{ height: 300, overflowY: "auto", paddingTop: "5px" }}>
              {dataArcticleCategory ? (
                renderCategoryTree(dataArcticleCategory)
              ) : (
                <p>Không có dữ liệu danh mục</p>
              )}
            </Box>
          </Group>
          <Group grow wrap="wrap" gap={"lg"}>
            <TextInput
              label={"Tiêu đề"}
              placeholder={"Nhập tiêu đề"}
              withAsterisk
              mt="md"
              type="text"
              {...form.getInputProps("title")}
              onChange={(event) =>
                handleInputChange("title", event.target.value)
              }
            />
            <Box style={{ display: "flex", flex: 1, gap: "1rem" }}>
              <Select
                label="Thời gian của bài viết"
                placeholder="Thay đổi thời gian"
                data={[
                  { value: "now", label: "Thời gian tạo bài" },
                  { value: "custom", label: "Chọn thời gian" },
                ]}
                value={timeOption}
                onChange={(val) => setTimeOption(val || "")}
                mt="md"
                style={{
                  flex: 1,
                }}
                clearable
                // styles={{
                //   input: {
                //     color: "#000",
                //     fontWeight: 400,
                //   },
                // }}
              />
              {timeOption === "custom" && (
                <DateTimePicker
                  {...form.getInputProps("postedDate")}
                  value={
                    form.values.postedDate
                      ? new Date(form.values.postedDate)
                      : null
                  }
                  onChange={(value: any) =>
                    form.setFieldValue(
                      "postedDate",
                      moment(value).format("YYYY-MM-DD[T]HH:mm:ss")
                    )
                  }
                  locale="vi"
                  withAsterisk
                  mt="md"
                  label="Thời gian đăng tải"
                  placeholder="Thời gian đăng tải"
                  style={{
                    flex: 1,
                  }}
                />
              )}
              {timeOption === "now" && (
                <DateTimePicker
                  {...form.getInputProps("creationDate")}
                  value={
                    form.values.creationDate
                      ? new Date(form.values.creationDate)
                      : null
                  }
                  locale="vi"
                  mt="md"
                  label="Thời gian đăng tải"
                  minDate={new Date()}
                  placeholder="Thời gian đăng tải"
                  readOnly
                  style={{
                    flex: 1,
                  }}
                />
              )}
              {timeOption !== "now" && timeOption !== "custom" && (
                <DateTimePicker
                  value={
                    form.values.postedDate
                      ? new Date(form.values.postedDate)
                      : null
                  }
                  locale="vi"
                  mt="md"
                  label="Thời gian ban đầu"
                  minDate={new Date()}
                  readOnly
                  style={{
                    flex: 1,
                  }}
                />
              )}
            </Box>
          </Group>
          <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
            <Select
              mt={"md"}
              label="Index"
              placeholder="Index/NoIndex"
              data={[
                { value: "1", label: "Index" },
                { value: "0", label: "NoIndex" },
              ]}
              value={form.values.attribute1?.toString() ?? "0"}
              searchable
              onChange={(value) => form.setFieldValue("attribute1", value)}
            />
            <Select
              mt={"md"}
              label="Follow"
              placeholder="Follow/NoFollow"
              data={[
                { value: "1", label: "Follow" },
                { value: "0", label: "NoFollow" },
              ]}
              value={form.values.attribute2?.toString() ?? "0"}
              searchable
              onChange={(value) => form.setFieldValue("attribute2", value)}
            />
          </Group>
          <Group grow wrap="wrap" gap={"lg"}>
            <Select
              label={"Trạng thái"}
              placeholder={"Trạng thái"}
              // withAsterisk
              mt="md"
              data={[
                { value: "0", label: "Chờ duyệt" },
                { value: "1", label: "Cho hiển thị" },
                { value: "2", label: "Bản nháp" },
              ]}
              value={
                form.values.status !== null && form.values.status !== undefined
                  ? form.values.status.toString()
                  : null
              }
              onChange={(e) => handleChangeStatus(e)}
              clearable
            />
            <TextInput
              label={"Thứ tự"}
              placeholder={"Nhập thứ tự"}
              // withAsterisk
              mt="md"
              type="number"
              {...form.getInputProps("ordering")}
            />
          </Group>
          <Group grow wrap="wrap" gap={"lg"}>
            <Select
              label={"Nổi bật"}
              placeholder={"Nhập nổi bật"}
              withAsterisk
              mt="md"
              data={[
                { value: "Y", label: "Nổi bật" },
                { value: "N", label: "Không nổi bật" },
              ]}
              {...form.getInputProps("isStricking")}
              clearable
            />
            <TextInput
              label={"Mã video"}
              placeholder={"Nhập mã video"}
              mt="md"
              type="text"
              {...form.getInputProps("videoCode")}
            />
          </Group>
          <Group grow wrap="wrap" gap={"lg"}>
            <TextInput
              label={"Url ngoại tuyến"}
              placeholder={"Nhập url ngoại tuyến"}
              mt="md"
              type="text"
              {...form.getInputProps("externalUrl")}
            />
            <TextInput
              label={"Url"}
              placeholder={"Nhập url"}
              mt="md"
              type="text"
              withAsterisk
              {...form.getInputProps("url")}
            />
          </Group>
          <Group grow wrap="wrap" gap={"lg"}>
            <TextInput
              label={"Đường dẫn yêu cầu"}
              placeholder={"Nhập đường dẫn yêu cầu"}
              mt="md"
              type="text"
              {...form.getInputProps("requestPath")}
            />
            <TextInput
              label={"Băm Url"}
              placeholder={"Nhập băm Url"}
              mt="md"
              type="text"
              {...form.getInputProps("urlHash")}
            />
          </Group>
          <Group grow wrap="wrap" gap={"lg"}>
            <Box>
              <FileInput
                leftSection={icon}
                label={"Hình thu nhỏ"}
                placeholder={"Nhập hình thu nhỏ"}
                accept="image/*"
                leftSectionPointerEvents="none"
                clearable
                mt="md"
                // {...form.getInputProps("thumnail")}
                // onChange={(file) => handleChangeImage(file, "thumnail")}
                // value={selectedImgUrl}
                onChange={handleImgUrlChange}
              />
              {form.values.thumnail && (
                <Text size="xs" mt={4} c="dimmed">
                  {form.values.thumnail.split("/").pop()}
                </Text>
              )}
              <Box
                mt="sm"
                style={{
                  border: "2px dashed #e9ecef",
                  borderRadius: "8px",
                  padding: "12px",
                  backgroundColor: "#f8f9fa",
                  textAlign: "center",
                }}
              >
                <Text size="xs" c="dimmed" mb="xs">
                  Ảnh thu nhỏ hiện tại
                </Text>
                <Box
                  style={{
                    borderRadius: "6px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    border: "1px solid #dee2e6",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: 140,
                  }}
                >
                  {form.getValues().thumnail ? (
                    <img
                      src={convertImageDomain(
                        form.getValues().thumnail?.toString() || ""
                      )}
                      alt="Preview Icon"
                      style={{
                        width: 120,
                        height: 120,
                        minWidth: 120,
                        minHeight: 120,
                        objectFit: "cover",
                        display: "block",
                        margin: "auto",
                        cursor: "pointer",
                      }}
                      onDoubleClick={() => {
                        setModalImageUrl(
                          form.getValues().thumnail?.toString() || ""
                        );
                        setZoomLevel(1);
                        setModalOpened(true);
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: 120,
                        height: 120,
                        minWidth: 120,
                        minHeight: 120,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#f1f3f4",
                        color: "#6c757d",
                        fontSize: "12px",
                      }}
                    >
                      Chưa có ảnh
                    </div>
                  )}
                </Box>
              </Box>
            </Box>
            <Box>
              <FileInput
                leftSection={icon}
                label="Hình nền"
                placeholder="Chọn tệp..."
                accept="image/*"
                leftSectionPointerEvents="none"
                clearable
                mt="md"
                onChange={handleImgBigChange}
              />
              {form.values.imageBackground && (
                <Text size="xs" mt={4} c="dimmed">
                  {form.values.imageBackground.split("/").pop()}
                </Text>
              )}
              <Box
                mt="sm"
                style={{
                  border: "2px dashed #e9ecef",
                  borderRadius: "8px",
                  padding: "12px",
                  backgroundColor: "#f8f9fa",
                  textAlign: "center",
                }}
              >
                <Text size="xs" c="dimmed" mb="xs">
                  Hình nền hiện tại
                </Text>
                <Box
                  style={{
                    borderRadius: "6px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    border: "1px solid #dee2e6",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: 140,
                  }}
                >
                  {form.getValues().imageBackground ? (
                    <img
                      src={convertImageDomain(
                        form.getValues().imageBackground?.toString() || ""
                      )}
                      alt="Preview Background"
                      style={{
                        width: 120,
                        height: 120,
                        minWidth: 120,
                        minHeight: 120,
                        objectFit: "cover",
                        display: "block",
                        margin: "auto",
                        cursor: "pointer",
                      }}
                      onDoubleClick={() => {
                        setModalImageUrl(
                          form.getValues().imageBackground?.toString() || ""
                        );
                        setZoomLevel(1);
                        setModalOpened(true);
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: 120,
                        height: 120,
                        minWidth: 120,
                        minHeight: 120,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#f1f3f4",
                        color: "#6c757d",
                        fontSize: "12px",
                      }}
                    >
                      Chưa có ảnh
                    </div>
                  )}
                </Box>
              </Box>
            </Box>
          </Group>
          <Textarea
            label={"Tóm tắt"}
            placeholder={"Nhập tóm tắt"}
            withAsterisk
            mt="md"
            {...form.getInputProps("summary")}
            onChange={(event) =>
              handleInputChange("summary", event.target.value)
            }
          />
          <p style={{ fontSize: 12.25 }}>
            Số từ:{" "}
            <span style={{ fontWeight: 500 }}>{countWords(summary)} </span>, Số
            kí tự:{" "}
            <span style={{ fontWeight: 500 }}>{countCharacters(summary)}</span>
          </p>
          <Text size="sm" mt="sm" fw={500}>
            Nội dung
          </Text>
          <QuillEditor
            toolbarId="t1"
            setValue={setValueDescription}
            // onChangeValue={(html: string) =>
            //   form.setFieldValue("content", handleChangeDataContent(html))
            // }
            description={handleChangeDataContent(form.getValues().content)}
          />
          <Group grow wrap="wrap" gap={"lg"}>
            <Textarea
              label={"Tags (Mỗi cụm từ 1 dòng)"}
              placeholder={"Nhập tags"}
              // withAsterisk
              mt="md"
              {...form.getInputProps("tags")}
            />
          </Group>
          {/* <Group grow wrap="wrap" gap={"lg"}>
            <TextInput
              label={"Tỷ lệ đánh giá"}
              placeholder={"Nhập tỷ lệ đánh giá"}
              mt="md"
              type="number"
              {...form.getInputProps("reviewRate")}
            />
            <TextInput
              label={"Số lượt đánh giá"}
              placeholder={"Nhập số lượt đánh giá"}
              mt="md"
              type="number"
              {...form.getInputProps("reviewCount")}
            />
          </Group> */}
          {/* <Group grow wrap="wrap" gap={"lg"}>
            <TextInput
              label={"Số lượt thích"}
              placeholder={"Nhập số lượt thích"}
              mt="md"
              type="number"
              {...form.getInputProps("likeCount")}
            />
            <TextInput
              label={"Lượt xem"}
              placeholder={"Nhập lượt xem"}
              mt="md"
              type="number"
              {...form.getInputProps("visit")}
            />
          </Group> */}
          {/* <Group grow wrap="wrap" gap={"lg"}>
            <TextInput
              label={"Số lượt bình luận"}
              placeholder={"Nhập số lượt bình luận"}
              mt="md"
              type="number"
              {...form.getInputProps("commentCount")}
            />
            <TextInput
              label={"Tỷ lệ bình luận"}
              placeholder={"Nhập tỷ lệ bình luận"}
              mt="md"
              type="number"
              {...form.getInputProps("commentRate")}
            />
          </Group> */}
          <Text size="sm" mt="sm" fw={700}>
            Dùng cho SEO
          </Text>
          <Group grow wrap="wrap" gap={"lg"}>
            <TextInput
              label={"Tiêu đề Meta"}
              placeholder={"Nhập tiêu đề meta"}
              withAsterisk
              {...form.getInputProps("metaTitle")}
              value={metaTitle}
              onChange={(event) =>
                handleInputChange("metaTitle", event.target.value)
              }
            />
            <p style={{ fontSize: 12.25, paddingTop: 20 }}>
              Số từ:{" "}
              <span style={{ fontWeight: 500 }}>{countWords(metaTitle)} </span>,
              Số kí tự:{" "}
              <span style={{ fontWeight: 500 }}>
                {countCharacters(metaTitle)}
              </span>
            </p>
          </Group>

          <Group grow wrap="wrap" gap={"lg"}>
            <TextInput
              label={"Từ khóa Meta"}
              placeholder={"Nhập từ khóa meta"}
              withAsterisk
              {...form.getInputProps("metaKeywords")}
              value={metaKeywords}
              onChange={(event) =>
                handleInputChange("metaKeywords", event.target.value)
              }
            />
            <p style={{ fontSize: 12.25, paddingTop: 20 }}>
              Số từ:{" "}
              <span style={{ fontWeight: 500 }}>
                {countWords(metaKeywords)}{" "}
              </span>
              , Số kí tự:{" "}
              <span style={{ fontWeight: 500 }}>
                {countCharacters(metaKeywords)}
              </span>
            </p>
          </Group>

          <Textarea
            label={"Mô tả Meta"}
            placeholder={"Nhập mô tả meta"}
            withAsterisk
            {...form.getInputProps("metaDescription")}
            value={metaDescription}
            onChange={(event) =>
              handleInputChange("metaDescription", event.target.value)
            }
          />
          <p style={{ fontSize: 12.25 }}>
            Số từ:{" "}
            <span style={{ fontWeight: 500 }}>
              {countWords(metaDescription)}{" "}
            </span>
            , Số kí tự:{" "}
            <span style={{ fontWeight: 500 }}>
              {countCharacters(metaDescription)}
            </span>
            <span style={{ fontWeight: 500 }}> (Khuyến nghị: 160 ký tự)</span>
          </p>
        </>

        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            color="#3598dc"
            leftSection={<IconCheck size={18} />}
            onClick={() => {
              const productData = {
                id: form.getValues().id,
                type: "edit",
                openModal: true,
                timestamp: new Date().getTime(),
              };
              localStorage.setItem(
                "hacom_edit_product",
                JSON.stringify(productData)
              );
              const baseUrl =
                window.location.origin + "/article-manager/article-list";
              const newWindow = window.open(baseUrl, "_blank");
              if (newWindow) newWindow.focus();
            }}
          >
            Mở trang tab
          </Button>
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
          <ButtonClose />
        </Group>
      </Box>
      <Modal
        opened={modalOpened}
        onClose={() => {
          setModalOpened(false);
          setZoomLevel(1);
        }}
        centered
        size="xl"
        title={
          <Group justify="space-between" style={{ width: "100%" }}>
            <Text fw={600}>Xem chi tiết ảnh</Text>
            <Group gap="xs">
              <Button
                variant="light"
                size="xs"
                leftSection={<IconMinus size={14} />}
                onClick={() =>
                  setZoomLevel((prev) => Math.max(0.25, prev - 0.25))
                }
                disabled={zoomLevel <= 0.25}
              >
                Zoom Out
              </Button>
              <Text size="sm" style={{ minWidth: "60px", textAlign: "center" }}>
                {Math.round(zoomLevel * 100)}%
              </Text>
              <Button
                variant="light"
                size="xs"
                leftSection={<IconPlus size={14} />}
                onClick={() => setZoomLevel((prev) => Math.min(3, prev + 0.25))}
                disabled={zoomLevel >= 3}
              >
                Zoom In
              </Button>
              <Button
                variant="light"
                size="xs"
                leftSection={<IconRotateClockwise size={14} />}
                onClick={() => setZoomLevel(1)}
              >
                Reset
              </Button>
            </Group>
          </Group>
        }
        overlayProps={{ zIndex: 999999 }}
        zIndex={999999}
        styles={{
          body: {
            padding: 0,
            overflow: "auto",
            maxHeight: "80vh",
          },
        }}
        style={{
          maxWidth: "95vw",
          maxHeight: "95vh",
        }}
      >
        {modalImageUrl && (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
              overflow: "auto",
              backgroundColor: "#f8f9fa",
            }}
          >
            <img
              src={modalImageUrl}
              alt="Ảnh chi tiết"
              style={{
                transform: `scale(${zoomLevel})`,
                transformOrigin: "center",
                transition: "transform 0.2s ease-in-out",
                maxWidth: "none",
                maxHeight: "none",
                display: "block",
                cursor: zoomLevel < 3 ? "zoom-in" : "zoom-out",
              }}
              onClick={() => {
                if (zoomLevel < 3) {
                  setZoomLevel((prev) => Math.min(3, prev + 0.25));
                } else {
                  setZoomLevel(1);
                }
              }}
            />
          </Box>
        )}
      </Modal>
    </>
  );
};

export default EditView;
